import { EDITOR_LIMITS } from "@/payroll/editor/constants";

export const fileFingerprint = (file: File) =>
  `${file.name}:${file.size}:${file.lastModified}`;

export const fileError = (file: File) => {
  if (file.size > EDITOR_LIMITS.fileBytes)
    return `${file.name}: Choose a file that is 20 MB or smaller.`;
  const extension = file.name.split(".").at(-1)?.toLowerCase();
  if (extension === "xls")
    return `${file.name}: Save this file as XLSX or CSV, then try again.`;
  if (
    ["pdf", "docx", "csv", "json", "xlsx"].includes(extension ?? "") ||
    [
      "application/pdf",
      "application/json",
      "application/csv",
      "text/csv",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ].includes(file.type)
  )
    return "";
  if (file.type === "application/vnd.ms-excel")
    return `${file.name}: Save this file as XLSX or CSV, then try again.`;
  const images = ["image/gif", "image/jpeg", "image/png", "image/webp"];
  if (
    ["heic", "heif"].includes(extension ?? "") ||
    (file.type.startsWith("image/") && !images.includes(file.type))
  )
    return `${file.name}: This image format is not supported. Save it as JPG or PNG, then try again.`;
  if (
    ["gif", "jpeg", "jpg", "png", "webp"].includes(extension ?? "") ||
    images.includes(file.type) ||
    file.type.startsWith("text/") ||
    ["log", "markdown", "md", "txt", "xml", "yaml", "yml"].includes(
      extension ?? "",
    )
  )
    return "";
  return `${file.name}: This format is not supported. Use PDF, DOCX, XLSX, CSV, text, JPG, PNG, GIF, or WebP.`;
};
